import * as types from "../types";

export const startLoader = dispatch =>
  dispatch({
    type: types.REQUEST_LOADER,
    value: true
  });

export const stopLoader = dispatch =>
  dispatch({
    type: types.REQUEST_LOADER,
    value: false
  });

export const openSnackbar = message => {
  return {
    type: types.OPEN_SNACKBAR,
    message
  };
};

export const openSnackbarDispatch = (dispatch, message) => {
  dispatch({
    type: types.OPEN_SNACKBAR,
    message
  });
}

export const changeCookieAcceptation = value => {
  return dispatch => {
      dispatch({
          type: types.SET_COOKIES_ACCEPTED,
          value: value
      });
  };
};